import {
  isAlreadyProcessed,
  variantForLevel
} from '../model/notification-decisions'

/**
 * Exposes the pure notification deciders to the component layer. Components
 * must not value-import `model/` directly (the MVVM internal-import rule);
 * this composable is the blessed indirection per the Vue MVVM contract.
 */
export function useNotificationDecisions() {
  return {
    /** Map a `NotificationLevel` to the Toaster variant it should render as. */
    variantForLevel,
    /** True when `id` is already present in the in-flight `processed` set. */
    isAlreadyProcessed
  }
}
